import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0a1628] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_f99a18a4-e930-4176-ac10-f2e206aadd3b/artifacts/tclbelzy_content.png" 
              alt="Kalinda for NYS Assembly" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              Fighting for school choice, safe communities, and affordability for Monroe County families.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white/90">Quick Links</h3>
            <div className="space-y-3">
              <Link to="/meet-kalinda" className="block text-white/60 hover:text-red-500 transition-colors text-sm">
                Meet Kalinda
              </Link>
              <Link to="/issues" className="block text-white/60 hover:text-red-500 transition-colors text-sm">
                Issues
              </Link>
              <Link to="/volunteer" className="block text-white/60 hover:text-red-500 transition-colors text-sm">
                Get Involved
              </Link>
              <Link to="/news" className="block text-white/60 hover:text-red-500 transition-colors text-sm">
                News
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white/90">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Mail className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <a 
                  href="mailto:kalinda@kalindafornysassembly.com" 
                  className="text-white/60 text-sm hover:text-red-500 transition-colors"
                >
                  kalinda@kalindafornysassembly.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 mt-0.5 text-red-500 flex-shrink-0" />
                <span className="text-white/60 text-sm">Rochester, NY 14614</span>
              </div>
            </div>
          </div>

          {/* Social & Donate */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white/90">Follow Us</h3>
            <div className="flex space-x-3 mb-6">
              <a
                href="https://www.facebook.com/share/1E1zLz6hvX/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="https://www.instagram.com/kalindafornysa?igsh=MWFkOW9jaWE3OHFidw%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
            <a 
              href="https://buy.stripe.com/4gMeVec2v4oP6XP3sQ6g803" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-2.5 text-sm uppercase tracking-wider rounded transition-all duration-300"
            >
              Donate
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-xs text-white/50">
              Paid for by Kalinda Washington for New York State Assembly
            </p>
            <p className="text-xs text-white/40">
              © {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
